import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";
import { createInventoryHealthMatrix } from "../../utils/inventory_health_matrix";

export const InventoryHealthContainer = () => {
  // Customer-specific date hierarchy configurations
  const dateHierarchyColumnFilter = {
    week: "week",
    month: "month",
    day: "day",
  };

  // Hardcoded measure options for the dropdown
  const measureColumnFilter = (params: DatePivotParams) => {
    const dateHierarchy =
      params.dateHierarchy.charAt(0).toUpperCase() +
      params.dateHierarchy.slice(1) +
      "s";
    return {
      "Purchase Order To Place": "Purchase Order To Place",
      "Starting Inventory On Hand": "Starting Inventory On Hand",
      "Forecasted Sales": "Forecasted Sales",
      "purchase order arrivals": "PO Arrivals",
      "Ending Inventory On Hand": "Ending Inventory On Hand",
      "Unfulfilled Demand": "Unfulfilled Demand",
      [`Target ${dateHierarchy} of Supply`]: `Target ${dateHierarchy} of Supply`,
      [`Starting ${dateHierarchy} of Supply`]: `Starting ${dateHierarchy} of Supply`,
      [`Ending ${dateHierarchy} of Supply`]: `Ending ${dateHierarchy} of Supply`,
      "In Stock Rate": "In Stock Rate",
    };
  };

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_test",
        transformId: "supply_walk_parallelized",
        folder: "outputs",
        title: "Inventory Health",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: [],
        measureColumnFilter,
        // Keep Filter-by to real dimensions. is_end_of_life is redundant with
        // sku_status (Active/EOL); the rest are per-unit numeric attributes cast
        // to strings that make no sense as filters.
        excludedFilterColumnFilter: [
          "is_end_of_life",
          "moq",
          "units_per_pallet",
          "share",
          "weight_in_pounds",
          "desired_weeks_of_supply",
          "qty_per_case",
          "pallets_per_truck",
          "category_po_code",
        ],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.EnableChartView,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createInventoryHealthMatrix,
        chunkedMatrixTransformId: "supply_walk_parallelized_matrix",
        excludeDetailRows: true,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
